/*
 * A PDF's first page as a picture, drawn here in the browser: the card cover a
 * prospect sees on the room (migration 071). pdf.js is loaded from cdnjs the
 * first time it is needed, so the CRM's bundle does not carry a PDF renderer for
 * the one screen that uses it. Any failure is "no cover", never an error: the
 * card falls back to its coloured block.
 */
const PDFJS = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174";
let loading = null;

function loadPdfJs() {
  if (typeof window === "undefined") return Promise.reject(new Error("no window"));
  if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
  if (!loading) {
    loading = new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = `${PDFJS}/pdf.min.js`;
      s.async = true;
      s.onload = () => {
        if (!window.pdfjsLib) return reject(new Error("pdf.js did not load"));
        window.pdfjsLib.GlobalWorkerOptions.workerSrc = `${PDFJS}/pdf.worker.min.js`;
        resolve(window.pdfjsLib);
      };
      s.onerror = () => {
        loading = null;
        reject(new Error("pdf.js did not load"));
      };
      document.head.appendChild(s);
    });
  }
  return loading;
}

/** A PDF (File, Blob or ArrayBuffer) → a JPEG Blob of page 1, 900px wide; null when it cannot be drawn. */
export async function pdfCover(source, { width = 900 } = {}) {
  try {
    const pdfjs = await loadPdfJs();
    const data = source instanceof ArrayBuffer ? source : await source.arrayBuffer();
    const doc = await pdfjs.getDocument({ data }).promise;
    const page = await doc.getPage(1);
    const base = page.getViewport({ scale: 1 });
    const viewport = page.getViewport({ scale: width / base.width });
    const canvas = document.createElement("canvas");
    canvas.width = Math.round(viewport.width);
    canvas.height = Math.round(viewport.height);
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    await page.render({ canvasContext: ctx, viewport }).promise;
    const blob = await new Promise((r) => canvas.toBlob(r, "image/jpeg", 0.85));
    doc.destroy();
    return blob;
  } catch (err) {
    console.warn("PDF cover not drawn:", err.message);
    return null;
  }
}

/** Draw it and upload it as a room file: → file id, or null. */
export async function uploadPdfCover(source, upload) {
  const blob = await pdfCover(source);
  if (!blob) return null;
  const file = new File([blob], "cover.jpg", { type: "image/jpeg" });
  const { file: saved } = await upload(file);
  return saved ? saved.id : null;
}
